/* eslint-disable @typescript-eslint/no-explicit-any */

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { filterParams } from 'src/app/core/models/request';

@Injectable({
  providedIn: 'root',
})
export class InputAutocompleteService {
  private http = inject(HttpClient);

  get(url: string, params: any = {}, page = 0, pageSize = 10, resDataInContent: boolean): Observable<any> {
    return this.http
      .get<any>(url, {
        params: filterParams({
          ...params,
          size: pageSize,
          page,
        }),
      })
      .pipe(
        map(res => {
          return (resDataInContent ? res.data.content : res.data) || [];
        })
      );
  }
}
